/**
 * 封装请求数据API
 */
import Dialog from 'c-dialog';
import env from 'c-nenv';
import Url from 'c-url';
import lang from '../lang/index';
import loading from 'c-up-loading';

module.exports = {
    /**
     * 发送请求
     */
    fetch: function(cfg) {
        let promise;

        cfg.data = cfg.data || {};
        cfg.data.t = new Date().getTime();
        // cfg.data.lang = lang.getLanguage();
        
        promise = $.ajax({
            url: cfg.url,
            data: cfg.data || {},
            type: cfg.type || 'GET',
            dataType: cfg.dataType || 'json',
            timeout: cfg.timeout || 10 * 1000,
            headers: cfg.headers,
            async: cfg.async
        });

        // 请求成功
        promise.done((res) => {
            if (res.errcode == "1000001" || res.errcode == '1000004') {
                //$.channel.emit('authorize'); // usertoken登录失效
            } else if (res.errcode == '1000002') {
                this.failure({
                    errcode: res.errcode,
                    errmsg: res.errmsg
                });
            }
        });

        // 请求失败
        promise.fail((xhr, errorType, error) => {
            this.failure({
                errcode: errorType,
                errmsg: error
            });
        });

        return promise;
    },
    /**
     * 请求失败
     */
    failure: function({
        errcode = '',
        errmsg = lang.template('系统异常')
    } = {}) {

        errmsg = errmsg || lang.template('系统异常');

        if (this.dialog) return; // 只显示一个弹出层即可

        this.dialog = new Dialog({
            content: errmsg + (errcode ? '<br/>(' + errcode + ')' : '')
        });

        loading.hide();

        this.dialog.create();
    }
}



// WEBPACK FOOTER //
// ./js/global/http.js